import {
	Footer as DsFooter,
	FooterSection,
	FooterSectionGroup,
	GlobalFooter,
	LegalLinks,
	SocialLinks,
	TrackingLink,
	type CustomSection,
	type SocialLinkItem,
} from '@ds-mgnl/marketing';
import { Image, Link, Text, type ImageProps } from '@dsx/react';
import footerLogo from '../../assets/images/ds-logo-color.svg';
import styles from './Footer.module.css';

export const Footer = () => {
	const currentYear = new Date().getFullYear();
	const copyright = `©2009-${currentYear} Direct Supply, Inc. All rights reserved.`;

	const logo: ImageProps = {
		src: footerLogo,
		alt: 'Direct Supply Logo',
	};

	const socialLinks: SocialLinkItem[] = [
		{
			href: 'https://x.com/_DirectSupply',
			site: 'twitterX',
		},
		{
			href: 'https://www.linkedin.com/company/direct-supply',
			site: 'linkedin',
		},
	];

	const customSections: CustomSection[] = [
		{
			section: {
				title: 'pac-IQ',
			},
			linkGroups: [
				{
					title: 'Features',
					links: [
						{ href: '/features/tools', children: 'Tools' },
						{ href: '/features/capabilities', children: 'Capabilities' },
						{ href: '/features/integrations', children: 'Integrations' },
						{ href: 'https://www.referral-iq.com/', children: 'Sign In' },
					],
				},
				{
					title: 'Solutions',
					links: [
						{
							href: '/solutions/admissions-workflow',
							children: 'Admissions Workflow',
						},
						{
							href: '/solutions/post-acute-referral-management',
							children: 'Post-Acute Referral Management',
						},
						{
							href: '/solutions/patient-navigation-software',
							children: 'Patient Navigation Software',
						},
					],
				},
				{
					links: [
						{ href: '/contact/support', children: 'Support' },
						{ href: '/resources/blogs', children: 'Expertise' },
					],
				},
			],
		},
	];

	return (
		<GlobalFooter
			logo={logo}
			socialLinks={socialLinks}
			customSections={customSections}
		/>
	);
};
